<template>
  <card class="card">
    <h4 class="text-center">Social Media Profiles</h4>
    <div class="row">
      <div class="col-md-6 text-left">
        <a href="#" @click.prevent="refreshProfiles">
          <em class="tim-icons icon-refresh-02" :class="refreshingAnimation" style="font-size: 22px; margin-bottom: 10px; margin-top: 10px"></em>
        </a>
      </div>
      <div class="col-md-6 text-right">
        <button type="button" class="btn btn-primary mb-4 float-right" @click="showAddProfileDialog = true">
          Add Profile
        </button>
      </div>
    </div>
    <vue-good-table
      :columns="columns"
      :rows="profiles"
      theme="nocturnal"
      :search-options="{ enabled: true }"
      :pagination-options="{ enabled: true, perPage: 10, allLabel: 'All' }"
    >
      <div slot="emptystate">
        <span v-show="isLoading">Loading...</span>
        <span v-show="!isLoading">No social media profiles found.</span>
      </div>

      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'social_links'">
          <template v-for="(url, platform, index) in props.row.social_media_urls">
            <template v-if="url">
              <a :key="platform" :href="url" target="_blank">{{ platform.charAt(0).toUpperCase() + platform.slice(1) }}</a>
              <base-button :key="`btn-${platform}`" icon round class="ml-1 mr-4" @click="copyToClipboard(url)">
                <i class="tim-icons icon-single-copy-04"></i>
              </base-button>
            </template>
          </template>
        </span>
        <span v-else-if="props.column.field === 'actions'">
          <base-button icon round @click="editProfile(props.row)">
            <i class="tim-icons icon-pencil"></i>
          </base-button>
          <base-button icon round @click="deleteProfile(props.row.id)">
            <i class="tim-icons icon-trash-simple"></i>
          </base-button>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <add-social-media-dialog
      :showAddProfileDialog="showAddProfileDialog"
      :editProfileData="currentEditProfile"
      @close="closeProfileDialog"
      @added="refreshProfiles"
      @updated="refreshProfiles" />
  </card>
</template>

<script>
import axios from "axios";
import formatDateTime from "@/mixin/formatDateTime";
import AddSocialMediaDialog from "@/components/AddSocialMediaProfileDialog.vue";

export default {
  name: "SocialMediaProfiles",
  mixins: [formatDateTime],
  components: {
    AddSocialMediaDialog
  },
  data() {
    return {
      showAddProfileDialog: false,
      isLoading: true,
      isRefreshing: false,
      refreshingAnimation: "",
      profiles: [],
      currentEditProfile: null,
      columns: [
        { label: 'Profile Name', field: 'name' },
        { label: 'Social Links', field: 'social_links', sortable: false },
        { label: 'Actions', field: 'actions', sortable: false, width: "120px" }
      ]
    };
  },
  watch: {
    isRefreshing() {
      this.refreshingAnimation = this.isRefreshing ? "rotating" : "";
    }
  },
  mounted() {
    this.getSocialMediaProfiles();
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text)
        .then(() => {
          this.$notify({
            type: 'success',
            message: 'Link copied to clipboard!',
            icon: 'tim-icons icon-check-2'
          });
        })
        .catch(err => {
          console.error("Failed to copy link: ", err);
          this.$notify({
            type: 'danger',
            message: 'Failed to copy link',
            icon: 'tim-icons icon-alert-circle-exc'
          });
        });
    },
    getSocialMediaProfiles() {
      this.isLoading = true;
      axios.get('/social-media-profiles')
        .then(response => {
          this.profiles = Array.isArray(response.data.data) ? response.data.data : [response.data.data];
        })
        .catch(error => {
          console.error("Error fetching social media profiles:", error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isRefreshing = false;
        });
    },
    editProfile(profile) {
      this.currentEditProfile = profile;
      this.showAddProfileDialog = true;
    },
    deleteProfile(id) {
      axios.delete(`/social-media-profiles/${id}`)
        .then(() => {
          this.getSocialMediaProfiles();
        })
        .catch(error => {
          console.error("Error deleting social media profile:", error);
        });
    },
    closeProfileDialog() {
      this.showAddProfileDialog = false;
      this.currentEditProfile = null;
    },
    refreshProfiles() {
      this.isRefreshing = true;
      this.getSocialMediaProfiles();
    }
  }
};
</script>
